var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrayRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 4H6a2 2 0 00-2 2v20a2 2 0 002 2h20a2 2 0 002-2V6a2 2 0 00-2-2zm0 2v13h-3.587a1.983 1.983 0 00-1.413.586L18.586 22h-5.172L11 19.586A1.98 1.98 0 009.586 19H6V6h20zm0 20H6v-5h3.586L12 23.414a1.98 1.98 0 001.414.586h5.172A1.984 1.984 0 0020 23.414L22.414 21H26v5z"
  })));
}
export default SvgTrayRegular;